<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form
              class="needs-validation"
              @submit.prevent="submitFilter"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="6">
                  <b-form-group label="Bulan" label-for="bulanFilter">
                    <b-form-select
                      v-model="bulanFilter"
                      id="bulanFilter"
                      :options="dataBulan"
                    />
                  </b-form-group>
                </b-col> -->
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'cetakQrCode')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="
                        !$can('Filter', 'cetakQrCode') &&
                          !$can('Filter-PdUpd', 'cetakQrCode')
                      "
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="KIB"
                    label-for="kibFilter"
                  >
                    <b-form-select
                      id="kibFilter"
                      v-model="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Ukuran"
                    label-for="ukuranFilter"
                  >
                    <b-form-select
                      id="ukuranFilter"
                      v-model="ukuranFilter"
                      :options="dataUkuran"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Keberadaan"
                    label-for="keberadaanFilter"
                  >
                    <b-form-select
                      id="keberadaanFilter"
                      v-model="keberadaanFilter"
                      :options="dataKeberadaan"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Status"
                    label-for="statusFilter"
                  >
                    <b-form-select
                      id="statusFilter"
                      v-model="statusFilter"
                      :options="dataStatus"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col
                cols="12"
                align="right"
                class="pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  Filter
                </b-button>
              </b-col>
            </b-form>
          </b-col>
          <b-col
            cols="12"
            align="right"
          >
            <b-button
              v-if="dataSelectedRows.length > 0 && $can('Print', 'cetakQrCode')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="lg"
              @click="clickPrint"
            >
              <div v-if="isPrint">
                <b-spinner small />
                <span class="sr-only">Loading...</span>
              </div>
              <div v-else>
                Print QR ({{ dataSelectedRows.length }})
              </div>
            </b-button>
          </b-col>
          <b-col
            cols="12"
            class="mt-2"
          >
            <!-- table -->
            <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              :is-loading.sync="isLoading"
              :select-options="{
                enabled: true,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }"
              @on-selected-rows-change="selectionChangedTable"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <span v-if="props.row.status != 1 && props.row.status != 4">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-body align-middle mr-25"
                        />
                      </template>
                      <b-dropdown-item :to="{name: 'validasiKeberadaanValidasi', params: { id: props.row.id }}">
                        <feather-icon
                          icon="Edit2Icon"
                          class="mr-50"
                        />
                        <span>Validasi</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'kobar_108'">
                  {{ props.row.kobar_108 }}
                  <br>
                  Noreg: {{ props.row.noreg_108 }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  <b-badge
                    v-if="props.row.status == 1"
                    variant="light-secondary"
                  >
                    Belum Input Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 2"
                    variant="light-info"
                  >
                    Belum Validasi Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 3"
                    variant="light-danger"
                  >
                    Dikembalikan Keberadaan
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 4"
                    variant="light-success"
                  >
                    Melakukan Input Pada Web
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 5"
                    variant="light-info"
                  >
                    Menunggu Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 6"
                    variant="light-danger"
                  >
                    Dikembalikan Validasi Data Informasi
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 7"
                    variant="light-secondary"
                  >
                    Belum Cetak QR
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 8"
                    variant="light-primary"
                  >
                    Belum Scan QR dan Foto
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.status == 9"
                    variant="light-success"
                  >
                    Selesai Inventarisasi
                  </b-badge>
                  <div v-if="props.row.kode_barcode">
                    Barcode : {{ props.row.kode_barcode }}
                  </div>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BBadge,
  BDropdown,
  BDropdownItem,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import { generateYears, startYear, generateMonths } from '@/libs/helper'
import master from '@/composables/master'
import cetakDaftarBmd from '@/composables/cetakDaftarBmd'
import cetakQrCode from '@/composables/cetakQrCode'
import apiTelegram from '@/composables/telegram/sendData'

const { showNotifikasi } = require('../../libs/helper')

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const month = moment().format('M')

    const tahunFilter = ref($route.query.tahun || year)
    const bulanFilter = ref($route.query.bulan || month)
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const kibFilter = ref($route.query.kib || 'C')
    const wilayahFilter = ref($route.query.wilayah || '')
    const keberadaanFilter = ref($route.query.keberadaan || 1)
    const statusFilter = ref($route.query.status || '7')
    const ukuranFilter = ref($route.query.ukuran || 2)
    const isPrint = ref(false)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') {
      wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10)
    }

    const dataTahun = ref(generateYears(startYear, year))
    const dataBulan = ref(generateMonths())
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const dataKib = ref([{ text: '-- Semua --', value: '' }])
    const dataProvinsi = ref([])
    const dataWilayah = ref([])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataKeberadaan = ref([{ value: '1', text: 'Ada' }])
    const dataStatus = ref([
      { value: '7', text: 'Belum Cetak QR' },
      { value: '8', text: 'Belum Scan QR dan Foto' },
      { value: '9', text: 'Selesai Inventarisasi' },
    ])
    const dataSelectedRows = ref([])
    const dataUkuran = ref([{ text: '15 x 10', value: 2 }])

    // variable untuk table
    const rows = ref([])
    const searchTerm = ref('')
    const start = ref(1)
    const row = ref(100000000)
    const totalRecords = ref(0)
    const sortColumn = ref('')
    const order = ref('')
    const isLoading = ref(false)

    // fungsi ambil data untuk table
    const datatable = async () => {
      isLoading.value = true

      const params = {
        filter_kib: kibFilter.value,
        filter_tahun: tahunFilter.value,
        filter_upd: pdUpdFilter.value,
        kode_wilayah: wilayahFilter.value,
        filter_status: statusFilter.value,
        filter_keberadaan: keberadaanFilter.value,
        length: row.value,
        start: start.value - 1,
        cari: searchTerm.value,
      }
      const resBmd = await cetakDaftarBmd.getBmd(g, params)
      const { code, list, totalList } = resBmd

      if (code == 200) {
        rows.value = list
        totalRecords.value = totalList
      } else {
        rows.value = []
        totalRecords.value = 0
      }

      isLoading.value = false
    }

    const clickPrint = async () => {
      isPrint.value = true
      try {
        let width = 100
        let height = 65
        if (ukuranFilter.value == 1) {
          width = 100
          height = 65
        } else {
          width = 100
          height = 150
        }

        const listId = []
        const listIdBelumCetak = []

        for (let i = 0; i < dataSelectedRows.value.length; i += 1) {
          listId.push(dataSelectedRows.value[i].id)
          if (dataSelectedRows.value[i].status == 7) {
            listIdBelumCetak.push(dataSelectedRows.value[i].id)
          }
        }

        let data = {
          format: 'pdf',
          width,
          height,
          id: listId,
        }

        const pdfFile = await cetakQrCode.printQrCode(g, data)
        if (pdfFile) window.open(URL.createObjectURL(pdfFile), '_blank')

        if (listIdBelumCetak.length > 0) {
          data = {
            list_id: listIdBelumCetak,
            id_emp: g.$cookies.get('username'),
          }

          await cetakQrCode.updateStatusQr(g, data)
        }

        datatable()
      } catch (error) {
        const pesanError = {
          sourceSystem: 'inventarisasiPengguna',
          action: 'printQr',
          pesan: error,
          idUser: g.$cookies.get('username'),
          type: 'info',
          system: 'frontend',
        }
        apiTelegram.sendMessage(g, { text: JSON.stringify(pesanError) })
        showNotifikasi(g, 'danger', 'Gagal Cetak Barcode', error)
      }
      isPrint.value = false
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&status=${statusFilter.value}&kib=${kibFilter.value}&tahun=${tahunFilter.value}`
      window.history.pushState('', '', url)
      start.value = 1
      datatable()
    }

    const handleSearch = () => {
      start.value = 1
      datatable()
    }

    const handlePageChange = () => {
      start.value = 1
      datatable()
    }

    const handleChangePage = page => {
      start.value = (page - 1) * row.value + 1
      datatable()
    }

    const onSortChange = params => {
      sortColumn.value = params[0].field
      order.value = params[0].type
      datatable()
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataKib.value = resKib
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    getPdUpd()

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) pdUpdFilter.value = pdUpdFilterValue.value.value
    }

    const selectionChangedTable = data => {
      dataSelectedRows.value = data.selectedRows
    }

    getKib()
    getWilayah()
    if (wilayahFilter.value) changeWilayah()

    return {
      datatable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      changeWilayah,
      inputPdUpd,
      searchPdUpd,
      submitFilter,
      selectionChangedTable,
      clickPrint,
      rows,
      searchTerm,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoading,
      tahunFilter,
      pdUpdFilter,
      kibFilter,
      wilayahFilter,
      bulanFilter,
      keberadaanFilter,
      statusFilter,
      pdUpdFilterValue,
      ukuranFilter,
      isPrint,
      dataTahun,
      dataPdUpd,
      dataKib,
      dataProvinsi,
      dataWilayah,
      dataKecamatan,
      dataKelurahan,
      dataBulan,
      dataKeberadaan,
      dataStatus,
      dataSelectedRows,
      dataUkuran,
    }
  },
  components: {
    VueGoodTable,
    vSelect,
    BRow,
    BCol,
    BCard,
    BBadge,
    BDropdown,
    BDropdownItem,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columns: [
        {
          label: 'Guid ID',
          field: 'guid_aset',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok',
          sortable: false,
        },
        {
          label: 'Nalok',
          field: 'nalok',
          sortable: false,
        },
        {
          label: 'Kobar',
          field: 'kobar_108',
          sortable: false,
        },
        {
          label: 'Nabar',
          field: 'nabar_108',
          sortable: false,
        },
        {
          label: 'Harga',
          field: 'HARGA',
          sortable: false,
        },
        {
          label: 'Ukuran',
          field: 'UKU_SAT',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
        },
        {
          label: 'Tanggal Oleh',
          field: 'TGLOLEH',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
